import React from "react";
import { getIconById } from "../dataIcons";

//post, onMouseEnter, onMouseLeave, onClickPin, clicked
function Pin({point, clicked, set_hover, setIsHover}) {

    const pinStyle = {
        height: '28px',
        width: '28px',
        cursor: 'pointer',
        stroke: 'none',
        // outline: clicked?.id === post.id ? '1px solid red' : ''
        // outline: '1px solid red', width: '30px', height: '30px'
    };
    const circleStyle = {
        cursor: 'pointer',
        outline: clicked?.properties.id === point.properties.id ? '2px solid black' : ''
    }

    return (
        <>
            <div className={'rounded-full bg-gradient-to-b from-red-500 to-red-900 '} //( clicked?.id === post.id && 'bg-white')}
                 // onClick={onClick}
                 onMouseEnter={() => set_hover(point)}
                 onMouseLeave={() => setIsHover(false)}
                 style={circleStyle}
            >
                <img
                    style={pinStyle}
                    src={getIconById(point.properties.protest_type_id)}
                    alt='Иконка протеста'
                />
            </div>

        </>
    );
}

export default React.memo(Pin);
